import { z } from 'zod';

import { AdvisorParticipantZod } from 'types/zod/advisor-participant';

const SimpleAdvisorsGroupZod = z.object({
    groupId: z.number(),
    name: z.string(),
    admins: z.array(z.number()).optional(),
    parentGroupId: z.number().optional(),
    inviteCodes: z.array(z.string()).optional(),
    couponName: z.string().optional(),
    directInvoicing: z.boolean().optional(),
    numberOfAdvisors: z.number().optional(),
});

export const AdvisorsGroupZod = SimpleAdvisorsGroupZod.extend({
    children: z
        .object({
            groups: z
                .array(
                    SimpleAdvisorsGroupZod.pick({
                        groupId: true,
                        name: true,
                        parentGroupId: true,
                        numberOfAdvisors: true,
                    }),
                )
                .optional()
                .nullable(),
            advisors: z.array(AdvisorParticipantZod).nullable(),
        })
        .optional(),
});
export type AdvisorsGroup = z.infer<typeof AdvisorsGroupZod>;
